import { render, staticRenderFns } from "./ShowDamage.vue?vue&type=template&id=229bd28b&scoped=true"
import script from "./ShowDamage.vue?vue&type=script&lang=js"
export * from "./ShowDamage.vue?vue&type=script&lang=js"
import style0 from "./ShowDamage.vue?vue&type=style&index=0&id=229bd28b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229bd28b",
  null
  
)

export default component.exports